try {
  window.MonacoEnvironment = {
    getWorker: function (_, label) {
      try {
        switch (label) {
          case 'json':
            return new Worker(
              new URL('monaco-editor/esm/vs/language/json/json.worker.js', import.meta.url),
              { type: 'module' }
            );
          case 'css':
            return new Worker(
              new URL('monaco-editor/esm/vs/language/css/css.worker.js', import.meta.url),
              { type: 'module' }
            );
          case 'html':
            return new Worker(
              new URL('monaco-editor/esm/vs/language/html/html.worker.js', import.meta.url),
              { type: 'module' }
            );
          case 'typescript':
          case 'javascript':
            return new Worker(
              new URL('monaco-editor/esm/vs/language/typescript/ts.worker.js', import.meta.url),
              { type: 'module' }
            );
          default:
            return new Worker(
              new URL('monaco-editor/esm/vs/editor/editor.worker.js', import.meta.url),
              { type: 'module' }
            );
        }
      } catch (err) {
        console.log('Monaco worker failed to load:', err);
        return null; // fallback: disable worker silently
      }
    }
  };
} catch (err) {
  console.log('Failed to initialize MonacoEnvironment:', err);
}